import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { TID } from "@/constants/tids";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Autentificare reușită");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-[#D4AF37]/20 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-[#D4AF37]/10 blur-3xl" />
      </div>
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2">
            <div className="h-12 w-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center overflow-hidden">
              <img
                src="/autorio-logo.jpg"
                alt="AutoRIO"
                className="h-12 w-12 object-cover"
              />
            </div>
          </div>
          <h1 className="mt-5 text-2xl font-extrabold text-white">Panou Administrator</h1>
          <p className="mt-1 text-sm text-white/50">AutoRIO CMS</p>
        </div>

        <form
          onSubmit={submit}
          className="bg-white/[0.03] backdrop-blur border border-white/10 rounded-2xl p-7 space-y-4"
        >
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.14em] text-white/60 mb-1.5">
              Email
            </label>
            <input
              data-testid={TID.adminEmail}
              type="email"
              required
              className="w-full bg-white/5 border border-white/10 rounded-xl h-12 px-4 text-white placeholder:text-white/30 focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] text-sm outline-none transition-colors"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@autorio.ro"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.14em] text-white/60 mb-1.5">
              Parolă
            </label>
            <input
              data-testid={TID.adminPassword}
              type="password"
              required
              className="w-full bg-white/5 border border-white/10 rounded-xl h-12 px-4 text-white placeholder:text-white/30 focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] text-sm outline-none transition-colors"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid={TID.adminLoginSubmit}
            disabled={loading}
            className="w-full h-12 bg-[#D4AF37] hover:bg-[#E8C86A] disabled:opacity-60 text-[#0A0A0A] rounded-full font-semibold text-sm transition-colors"
          >
            {loading ? "Se verifică..." : "Autentificare"}
          </button>
        </form>

        <p className="text-center mt-6 text-xs text-white/40">
          Doar administratorii AutoRIO se pot autentifica aici.
        </p>
      </div>
    </div>
  );
}
